import React, { useContext } from "react";
import { CommonDataContext } from "context/CommonDataContext";
import { useSelector } from "react-redux";
import { getIsDarkMode } from "@/store/slices/webConfig";
import { ButtonV2 } from "components/V2/atoms/ButtonV2/ButtonV2";

export interface PaxCategoriesProps {
  ageGroup: string;
  ageInfo: string;
  updatePaxCount: (paxType: string, value: string) => void;
  isDescDisable: boolean;
  isIncDisable: boolean;
  value: number;
  paxType: string;
}

function PaxCategories({
  ageGroup,
  ageInfo,
  updatePaxCount,
  isDescDisable,
  isIncDisable,
  value,
  paxType
}: PaxCategoriesProps) {
  const { webConfig } = useContext(CommonDataContext);
  const enableExtraSeat = webConfig?.enableExtraSeat;
  const isDarkMode = useSelector(getIsDarkMode);

  // Determine icon color
  const iconColor = isDarkMode ? "#FFFFFF" : "#FF6300";
  const disableColor = isDarkMode ? "#666666" : "#f2f2f2";

  return paxType === "EXST" && !enableExtraSeat ? null : (
    <div className="flex justify-between h-14 items-center">
      <div sx={{ display: "flex", flexDirection: "column", marginBottom: "20px" }}>
        <h5 className="text-base font-semibold">{ageGroup}</h5>
        <h6 className="text-muted text-xs font-normal">{ageInfo}</h6>
      </div>
      <div className="flex items-center" sx={{ userSelect: "none" }}>
        <ButtonV2
          onClick={() => updatePaxCount(paxType, "REMOVE")}
          disabled={isDescDisable}
          aria-label={`${ageGroup} Minus`}
          className="mr-2"
          blok={{ variant: "icon", text: "" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill={isDescDisable ? disableColor : iconColor}
            width="24px"
            height="24px"
          >
            <path d="M7 12c0 .55.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1m5-10C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" />
          </svg>
        </ButtonV2>
        <span className="text-xl">{value}</span>
        <ButtonV2
          onClick={() => updatePaxCount(paxType, "ADD")}
          disabled={isIncDisable}
          aria-label={`${ageGroup} Plus`}
          className="ml-2"
           blok={{ variant: "icon", text: "" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill={isIncDisable ? disableColor : iconColor}
            width="24px"
            height="24px"
          >
            <path d="M12 7c-.55 0-1 .45-1 1v3H8c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V8c0-.55-.45-1-1-1m0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" />
          </svg>
        </ButtonV2>
      </div>
    </div>
  );
}

export default PaxCategories;
